export enum CookieConsentStatusEnum {
  Allow,
  Disallow,
  NotSpecified
}
